export default __webpack_public_path__ + "static/media/downloadfromgoogle.4641c9d4.png";